function defaultEqualityFunction<T>(item1: T, item2: T): boolean {
  return item1 === item2;
}

/**
 * Returns number of occurences of `item` in `array`.
 */
export default function count<T>(
  array: Array<T>,
  item: T,
  equalityFn: (item1: T, item2: T) => boolean = defaultEqualityFunction
): number {
  return array.filter((elem) => equalityFn(elem, item)).length;
}
